export default "__VITE_ASSET__FqMQlH8c__"